import React from "react";
import "./PaketBelajar.css";
import paket_1 from "../../assets/pricelist/Komando_Sector_1.webp";
import paket_2 from "../../assets/pricelist/Komando_Sector_2.webp";
import paket_3 from "../../assets/pricelist/Komando_Sector_3.webp";
import paket_4 from "../../assets/pricelist/Komando_Sector_4.webp";

const PaketBelajar = () => {
  return (
    <React.Fragment>
      <div id="paket" className="container-paket-belajar">
        <h1 className="title-paket-belajar">Pilihan Program</h1>
        <div className="box-paket-belajar">
          {/* <a
            href="https://api.whatsapp.com/send?phone=6281216365729&text=Halo%20Kak%20Nia%20https://camp.tarunapersada.com,%20Saya%20ingin%20daftar%20Training%20Camp%20Bimbel%20TNI-POLRI%20program%20belajar%20Komando%20Sector%201%20Bagaimana%20penjelasan%20detail%20Programnya?"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={paket_1} alt="Paket Bimbel Masuk Akmil" className="img-paket-belajar" />
          </a>
          <a
            href="https://api.whatsapp.com/send?phone=6281216365729&text=Halo%20Kak%20Nia%20https://camp.tarunapersada.com,%20Saya%20ingin%20daftar%20Training%20Camp%20Bimbel%20TNI-POLRI%20program%20belajar%20Komando%20Sector%202%20Bagaimana%20penjelasan%20detail%20Programnya?"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={paket_2} alt="Paket Bimbel Masuk Akmil" className="img-paket-belajar" />
          </a>
          <a
            href="https://api.whatsapp.com/send?phone=6285600422188&text=Halo%20Kak%20Dila%20https://camp.tarunapersada.com,%20Saya%20ingin%20daftar%20Training%20Camp%20Bimbel%20TNI-POLRI%20program%20belajar%20Komando%20Sector%203%20Bagaimana%20penjelasan%20detail%20Programnya?"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={paket_3} alt="Paket Bimbel Masuk Akmil" className="img-paket-belajar" />
          </a>
          <a
            href="https://api.whatsapp.com/send?phone=6285600422188&text=Halo%20Kak%20Dila%20https://camp.tarunapersada.com,%20Saya%20ingin%20daftar%20Training%20Camp%20Bimbel%20TNI-POLRI%20program%20belajar%20Komando%20Sector%204%20Bagaimana%20penjelasan%20detail%20Programnya?"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={paket_4} alt="Paket Bimbel Masuk Akmil" className="img-paket-belajar" />
          </a> */}

          {/* NEW */}

          <div className="bg-card-paket">
            <div className="title-card-paket">
              <div className="title-alfa">ALFA</div> CAMP
            </div>
            <p className="title-benefit-card-paket">Benefit Program :</p>
            <div className="box-list-benefit">
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Program Karantina 2 Minggu
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Latihan Binsik 3 kali per minggu
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Belajar Akademik / SKD / Psikologi setiap hari
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Modul Cetak Super prediktif
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Drilling soal setiap hari
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Tryout Akademik / SKD / Psikotes sistem CAT
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Grup belajar Eksklusif
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Full Akomodasi Makan dan Laundry
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Free Jersey Latihan
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Tryout Jasmani
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Pembentukan Mental Kepribadian
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Progress Report Berkala
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Free Konsultasi
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color-close">
                  close
                </span>{" "}
                Garansi Uang Kembali
              </li>
            </div>
            <a
              className="btn-card-list-paket"
              href="https://api.whatsapp.com/send?phone=6285600422188&text=Halo%20Kak%20Dila%20https://camp.tarunapersada.com,%20Saya%20ingin%20daftar%20Training%20Camp%20*Paket%20Delta*%20Bimbel%20TNI-POLRI%20program%20belajar%20Komando%20Sector%201%20Bagaimana%20penjelasan%20detail%20Programnya?"
            >
              DAFTAR SEKARANG
            </a>
          </div>
          {/* --- */}
          <div className="bg-card-paket">
            <div className="title-card-paket">
              <div className="title-alfa">BRAVO</div> CAMP
            </div>
            <p className="title-benefit-card-paket">Benefit Program :</p>
            <div className="box-list-benefit">
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Program Karantina 1 Bulan
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Latihan Binsik 3 kali per minggu
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Belajar Akademik / SKD / Psikologi setiap hari
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Modul Cetak Super prediktif
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Drilling soal setiap hari
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Tryout Akademik / SKD / Psikotes sistem CAT
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Grup belajar Eksklusif
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Full Akomodasi Makan dan Laundry
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Free Jersey Latihan
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Free Medical Check Up
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Pembentukan Mental Kepribadian
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Progress Report Berkala
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Free Konsultasi
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color-close">
                  close
                </span>{" "}
                Garansi Uang Kembali
              </li>
            </div>
            <a
              className="btn-card-list-paket"
              href="https://api.whatsapp.com/send?phone=6281216365729&text=Halo%20Kak%20Nia%20https://camp.tarunapersada.com,%20Saya%20ingin%20daftar%20Training%20Camp%20*Paket%20Bravo*%20Bimbel%20TNI-POLRI%20program%20belajar%20Komando%20Sector%201%20Bagaimana%20penjelasan%20detail%20Programnya?"
            >
              DAFTAR SEKARANG
            </a>
          </div>
          {/* --- */}
          <div className="bg-card-paket">
            {/* <button className="badge-card">👑 Best Program</button> */}
            <div className="title-card-paket">
              <div className="title-alfa">DELTA</div> CAMP
            </div>
            <p className="title-benefit-card-paket">Benefit Program :</p>
            <div className="box-list-benefit">
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                Program Karantina 3 Bulan
              </li>
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                Latihan Binsik 2 - 3 kali per minggu
              </li>
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                Belajar Akademik / SKD / Psikologi setiap hari
              </li>
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                Modul Cetak Super prediktif
              </li>
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                Drilling soal setiap hari
              </li>
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                Tryout Akademik / SKD / Psikotes sistem CAT
              </li>
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                Grup belajar Eksklusif
              </li>
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                Full Akomodasi Makan dan Laundry
              </li>
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                Free Jersey Latihan
              </li>
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                Free Medical Check Up
              </li>
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                Pembentukan Mental Kepribadian
              </li>
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                Progress Report Berkala
              </li>
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                Free Konsultasi
              </li>
              <li className="list-paket-card-paket">
                <span class="material-symbols-outlined w-color">check</span>{" "}
                <strong>Garansi Uang Kembali</strong>
              </li>
            </div>
            <a
              className="btn-card-list-paket"
              href="https://api.whatsapp.com/send?phone=6281216365729&text=Halo%20Kak%20Nia%20https://camp.tarunapersada.com,%20Saya%20ingin%20daftar%20Training%20Camp%20*Paket%20Alfa*%20Bimbel%20TNI-POLRI%20program%20belajar%20Komando%20Sector%201%20Bagaimana%20penjelasan%20detail%20Programnya?"
            >
              DAFTAR SEKARANG
            </a>
          </div>

          {/* PRIVAT */}
          <div className="bg-card-paket">
            <div className="title-card-paket">PRIVAT INTENSIF</div>
            <p className="title-benefit-card-paket">Benefit Program :</p>
            <div className="box-list-benefit">
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Sistem Belajar Privat
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Fleksibilitas Waktu Belajar dan Latihan
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Latihan Binsik Terprogram
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Belajar Akademik / SKD / Psikologi Intensif
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Modul Belajar Super Prediktif
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Drilling Soal Setiap pertemuan
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Tryout Akademik / SKD / Psikotes sistem CAT
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Tryout Jasmani Berkala
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Free Jersey Latihan
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Pembentukan Mental Kepribadian
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Free Konsultasi
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Dibimbing Mentor Profesional
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Progress Report Berkala
              </li>
            </div>
            <a
              className="btn-card-list-paket"
              href="https://api.whatsapp.com/send?phone=6285600422188&text=Kak%20Dila%20https://camp.tarunapersada.com,%2C%20saya%20ingin%20Daftar%20Program%20Privat%20Intensif%20Bimbel%20TNI%20Polri%20dan%20Kedinasan."
            >
              DAFTAR SEKARANG
            </a>
          </div>
          <div className="bg-card-paket">
            <div className="title-card-paket">SMALL CLASS</div>
            <p className="title-benefit-card-paket">Benefit Program :</p>
            <div className="box-list-benefit">
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Sistem Belajar Group
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Waktu Belajar dan Latihan terjadwal
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Latihan Binsik Terprogram
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Belajar Akademik / SKD / Psikologi Intensif
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Modul Belajar Super Prediktif
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Drilling Soal Setiap pertemuan
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Tryout Akademik / SKD / Psikotes sistem CAT
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Tryout Jasmani Berkala
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Free Jersey Latihan
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Pembentukan Mental Kepribadian
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Free Konsultasi
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Dibimbing Mentor Profesional
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Progress Report Berkala
              </li>
            </div>
            <a
              className="btn-card-list-paket"
              href="https://api.whatsapp.com/send?phone=6285600422188&text=Kak%20Dila%20https://camp.tarunapersada.com%2C%20saya%20ingin%20Daftar%20Program%20Small%20Class%20Bimbel%20TNI%20Polri%20dan%20Kedinasan."
            >
              DAFTAR SEKARANG
            </a>
          </div>
          <div className="bg-card-paket">
            <div className="title-card-paket">ONLINE CLASS</div>
            <p className="title-benefit-card-paket">Benefit Program :</p>
            <div className="box-list-benefit">
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Sistem Belajar Online
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Waktu Belajar Fleksibel
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Belajar Akademik / SKD / Psikologi Intensif
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                E-Book Soal dan Pembahasan
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Drilling Soal Setiap pertemuan
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Tryout Akademik / SKD / Psikotes sistem CAT
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Recording Pembelajaran
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Free Konsultasi
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Dibimbing Mentor Profesional
              </li>
              <li className="list-paket-card-paket">
                <span className="material-symbols-outlined w-color">check</span>{" "}
                Progress Report Berkala
              </li>
            </div>
            <a
              className="btn-card-list-paket"
              href="https://api.whatsapp.com/send?phone=6285600422188&text=Kak%20Dila%20https://camp.tarunapersada.com%2C%20saya%20ingin%20Daftar%20Program%20Oline%20Class%20Bimbel%20TNI%20Polri%20dan%20Kedinasan."
            >
              DAFTAR SEKARANG
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PaketBelajar;
